<template>
  <div class="social-media-links">
    <h1>Social media links</h1>
    <p>
      Add or remove social media links. Edit URL for individual links in the
      social media section.
    </p>
    <div class="wrapper">
      <div class="input-wrap">
        <div class="label-wrap">
          <label for="">Input Label</label>
          <span class="material-icons"> help_outline </span>
        </div>
        <a-input :value="data.label" @input="$emit('socialMediaLabel', $event.target.value)" :maxLength="255"/>
      </div>
      <div class="links-wrapper">
        <SingleSocialNetworkLink
          v-for="(n, idx) in networksArrWithUrl"
          :key="idx"
          :iconImg="n.iconImg"
          :networkName="n.networkName"
          :url="n.url"
          @socialNetwork="handleSocialNetwork"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SingleSocialNetworkLink from "./SingleSocialNetworkLink.vue";
export default {
  components: {
    SingleSocialNetworkLink,
  },
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      networksArr: [
        {
          iconImg: this.$images.youtube,
          networkName: "Youtube",
        },
        {
          iconImg: this.$images.twitter,
          networkName: "Twitter",
        },
        {
          iconImg: this.$images.linkedin,
          networkName: "linkedIn",
        },
        {
          iconImg: this.$images.facebook,
          networkName: "Facebook",
        },
        {
          iconImg: this.$images.instagram,
          networkName: "Instagram",
        },
      ],
    };
  },
  computed: {
    networksArrWithUrl () {
      return this.networksArr.map(el => {
        if (el.networkName === "Youtube") el.url = this.data.youtube;
        if (el.networkName === "Twitter") el.url = this.data.twitter;
        if (el.networkName === "linkedIn") el.url = this.data.linkedin;
        if (el.networkName === "Facebook") el.url = this.data.facebook;
        if (el.networkName === "Instagram") el.url = this.data.instagram;

        return el;
      })
    },
  },
  methods: {
    handleSocialNetwork(payload) {
      this.$emit('socialNetwork',payload)
    },
  },
};
</script>

<style lang='scss' scoped>
.social-media-links {
  margin: 45px 0;
  h1 {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    color: #001529;
    padding: 25px 0;
    border-bottom: 1px solid #cbcbe4;
  }
  .wrapper {
    max-width: 950px;
    .material-icons {
      color: #b2bac7;
      font-size: 14px;
      display: inline-block;
      margin: 0 5px;
    }
    .input-wrap {
      display: flex;
      margin: 25px 0;
      .label-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        label {
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 22px;
          color: #001529;
          width: 70px;
          input {
            width: 150px;
            height: 40px;
            background: #ffffff;
            border: 1px solid #dfe1e6;
            box-sizing: border-box;
            border-radius: 2px;
          }
        }
      }
    }
    .links-wrapper {
      min-height: 299px;
      background: #ffffff;
      border: 1px solid #dfe1e6;
      box-sizing: border-box;
      border-radius: 2px;
      padding: 10px 10px 10px 26px;
    }
  }
}
</style>

<style>
/* utility css for ant */
body
  > div
  > div
  > div.footer.admin-page
  > div.content-wrap
  > div.social-media-links
  > div
  > div.input-wrap
  > input {
  width: 150px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #dfe1e6;
  box-sizing: border-box;
  border-radius: 2px;
  padding: 5px 12px;
}
</style>